<template>
<div>
    <base-header v-once pageName="일일 리포트" :popup="true"></base-header>
    
    <section id="wrap">
        <div class="today"><h4>{{yrInfo}}년 {{mnInfo}}월 {{dayInfo}}일</h4></div>

        <ul class="tab tab-fix">
            <li><button type="button" @click="cusTab('ave')" :class="{ current : activeTab == 'ave'}">평균 대비 분석 결과</button></li>
            <li><button type="button" @click="cusTab('pre')" :class="{ current : activeTab == 'pre'}">전월 대비 분석 결과</button></li>
        </ul>
        
        <div class="reportMon-average" v-show="!view">
            <div class="header">
                <p>
                    <span>나(ME)</span>
                </p>
                <p>
                    <span>동일 직급 평균</span>
                </p>
            </div>
            <div class="wrap">
                <h6>판매활동</h6>
                <div class="brif">
                    <p>
                        <strong>{{mySale}}</strong>
                        <em>%</em>
                    </p>
                    <p>
                        <strong>{{avgSale}}</strong>
                        <em>%</em>
                    </p>
                </div>
                <ul class="chart-rod">
                    <li><p v-if="sectSr1 != 0" :style="{'width': widthChk(sectSr1)+'%'}">{{sectSr1}}</p></li>
                    <li>소스</li>
                    <li><p v-if="sectSr2 != 0" :style="{'width': widthChk(sectSr2)+'%'}">{{sectSr2}}</p></li>
                    <li><p v-if="sectDg1 != 0" :style="{'width': widthChk(sectDg1)+'%'}">{{sectDg1}}</p></li>
                    <li>진단</li>
                    <li><p v-if="sectDg2 != 0" :style="{'width': widthChk(sectDg2)+'%'}">{{sectDg2}}</p></li>
                    <li><p v-if="sectCo1 != 0" :style="{'width': widthChk(sectCo1)+'%'}">{{sectCo1}}</p></li>
                    <li>상담</li>
                    <li><p v-if="sectCo2 != 0" :style="{'width': widthChk(sectCo2)+'%'}">{{sectCo2}}</p></li>
                    <li><p v-if="sectKy1 != 0" :style="{'width': widthChk(sectKy1)+'%'}">{{sectKy1}}</p></li>
                    <li>계약</li>
                    <li><p v-if="sectKy2 != 0" :style="{'width': widthChk(sectKy2)+'%'}">{{sectKy2}}</p></li>
                </ul>
            </div>
            <div class="wrap">
                <h6>관리활동</h6>
                <div class="brif">
                    <p>
                        <strong>{{myMngt}}</strong>
                        <em>%</em>
                    </p>
                    <p>
                        <strong>{{avgMngt}}</strong>
                        <em>%</em>
                    </p>
                </div>
                <ul class="chart-rod">
                    <li><p v-if="sectAs1 != 0" :style="{'width': widthChk(sectAs1)+'%'}">{{sectAs1}}</p></li>
                    <li>A/S</li>
                    <li><p v-if="sectAs2 != 0" :style="{'width': widthChk(sectAs2)+'%'}">{{sectAs2}}</p></li>
                    <li><p v-if="sectBk1 != 0" :style="{'width': widthChk(sectBk1)+'%'}">{{sectBk1}}</p></li>
                    <li>북케어</li>
                    <li><p v-if="sectBk2 != 0" :style="{'width': widthChk(sectBk2)+'%'}">{{sectBk2}}</p></li>
                    <li><p v-if="sectEd1 != 0" :style="{'width': widthChk(sectEd1)+'%'}">{{sectEd1}}</p></li>
                    <li>교육</li>
                    <li><p v-if="sectEd2 != 0" :style="{'width': widthChk(sectEd2)+'%'}">{{sectEd2}}</p></li>
                </ul>
            </div>
        </div>

        <div class="reportMon-prevMon" v-show="view">
            <div class="wrap">
                <h6>판매활동</h6>
                <div class="note">
                    <span class="prev">전월 {{sectInfo}}</span>
                    <span class="curr">당월 {{sectInfo}}</span>
                </div>

                <ul>
                    <li>                        
                        <p>소스</p>
                        <span v-if="sectSr3 != 0" :style="{'height': heightChk(sectSr3)+'%'}"><em>{{sectSr3}}</em></span>
                        <span v-if="sectSr4 != 0" :style="{'height': heightChk(sectSr4)+'%'}"><em>{{sectSr4}}</em></span>
                    </li>
                    <li>
                        <p>진단</p>
                        <span v-if="sectDg3 != 0" :style="{'height': heightChk(sectDg3)+'%'}"><em>{{sectDg3}}</em></span>
                        <span v-if="sectDg4 != 0" :style="{'height': heightChk(sectDg4)+'%'}"><em>{{sectDg4}}</em></span>
                    </li>
                    <li>
                        <p>상담</p>
                        <span v-if="sectCo3 != 0" :style="{'height': heightChk(sectCo3)+'%'}"><em>{{sectCo3}}</em></span>
                        <span v-if="sectCo4 != 0" :style="{'height': heightChk(sectCo4)+'%'}"><em>{{sectCo4}}</em></span>
                    </li>
                    <li>
                        <p>계약</p>
                        <span v-if="sectKy3 != 0" :style="{'height': heightChk(sectKy3)+'%'}"><em>{{sectKy3}}</em></span>
                        <span v-if="sectKy4 != 0" :style="{'height': heightChk(sectKy4)+'%'}"><em>{{sectKy4}}</em></span>
                    </li>
                </ul>
            </div>
            <div class="wrap">
                <h6>관리활동</h6>
                <div class="note">
                    <span class="prev">전월 {{sectInfo}}</span>
                    <span class="curr">당월 {{sectInfo}}</span>
                </div>

                <ul>
                    <li>
                        <p>A/S</p>
                        <span v-if="sectAs3 != 0" :style="{'height': heightChk(sectAs3)+'%'}"><em>{{sectAs3}}</em></span>
                        <span v-if="sectAs4 != 0" :style="{'height': heightChk(sectAs4)+'%'}"><em>{{sectAs4}}</em></span>
                    </li>
                    <li>
                        <p>북케어</p>
                        <span v-if="sectBk3 != 0" :style="{'height': heightChk(sectBk3)+'%'}"><em>{{sectBk3}}</em></span>
                        <span v-if="sectBk4 != 0" :style="{'height': heightChk(sectBk4)+'%'}"><em>{{sectBk4}}</em></span>
                    </li>
                    <li>
                        <p>교육</p>
                        <span v-if="sectEd3 != 0" :style="{'height': heightChk(sectEd3)+'%'}"><em>{{sectEd3}}</em></span>
                        <span v-if="sectEd4 != 0" :style="{'height': heightChk(sectEd4)+'%'}"><em>{{sectEd4}}</em></span>
                    </li>
                </ul>

            </div>
        </div>
    </section>
</div>
</template>

<script>
export default {
  data() {
      return{     
          
        yrInfo : '',
        mnInfo : '',
        dayInfo : '',
        trgDate : this.$route.query.trgDate,

        myPoint : 0,
        avgPoint : 0,

        sectSr1 : '',
        sectSr2 : '',
        sectSr3 : '',
        sectSr4 : '',
        
        sectDg1 : '',
        sectDg2 : '',
        sectDg3 : '',
        sectDg4 : '',

        sectCo1 : '',
        sectCo2 : '',
        sectCo3 : '',
        sectCo4 : '',

        sectKy1 : '', 
        sectKy2 : '', 
        sectKy3 : '', 
        sectKy4 : '', 

        sectAs1 : '', 
        sectAs2 : '', 
        sectAs3 : '', 
        sectAs4 : '', 

        sectBk1 : '', 
        sectBk2 : '', 
        sectBk3 : '', 
        sectBk4 : '', 

        sectEd1 : '', 
        sectEd2 : '', 
        sectEd3 : '', 
        sectEd4 : '', 

        sectMywin : '', 
        sectAvgwin : '', 
        sectInfo : '',

        mySale : '',
        myMngt : '',
        avgSale : '',
        avgMngt : '',
        activeTab: "ave",
        view: false,

      };
  },
  created: function () {

    var thisDate = new Date();

    var thisYear = thisDate.getFullYear()+'';
    var thisMonth = ((thisDate.getMonth() + 1) < 10 ? '0' : '') + (thisDate.getMonth() + 1);
    var today = ("00"+(thisDate.getDate())).slice(-2); // 일 (2자리)

    if(this.trgDate == undefined || this.trgDate == '') {
        this.trgDate = thisYear+thisMonth+today;
    }

    var that = this;
        var parameters = {
            thisYrmn : that.trgDate
        };

    this.$api.mypage
    .dailyReport(parameters)
    .then(function(data) {
        
        if(data){

            that.yrInfo = data.yrInfo;
            that.mnInfo = data.mnInfo;
            that.dayInfo = data.dayInfo;
            that.sectSr1 = data.sectSr1;
            that.sectSr2 = data.sectSr2; 
            that.sectSr3 = data.sectSr3;
            that.sectSr4 = data.sectSr4;
            that.sectDg1 = data.sectDg1; 
            that.sectDg2 = data.sectDg2; 
            that.sectDg3 = data.sectDg3; 
            that.sectDg4 = data.sectDg4;
            that.sectCo1 = data.sectCo1; 
            that.sectCo2 = data.sectCo2; 
            that.sectCo3 = data.sectCo3; 
            that.sectCo4 = data.sectCo4;
            that.sectKy1 = data.sectKy1; 
            that.sectKy2 = data.sectKy2; 
            that.sectKy3 = data.sectKy3; 
            that.sectKy4 = data.sectKy4;
            that.sectAs1 = data.sectAs1; 
            that.sectAs2 = data.sectAs2;
            that.sectAs3 = data.sectAs3;
            that.sectAs4 = data.sectAs4;
            that.sectBk1 = data.sectBk1;
            that.sectBk2 = data.sectBk2;
            that.sectBk3 = data.sectBk3;
            that.sectBk4 = data.sectBk4;
            that.sectEd1 = data.sectEd1;
            that.sectEd2 = data.sectEd2;
            that.sectEd3 = data.sectEd3;
            that.sectEd4 = data.sectEd4;
            that.sectMywin = data.sectMywin;
            that.sectAvgwin = data.sectAvgwin;
            that.sectInfo = data.sectInfo;

            var saleSum = parseInt(that.sectSr1) + parseInt(that.sectDg1) + parseInt(that.sectCo1) + parseInt(that.sectKy1) ;
            var mngtSum = parseInt(that.sectAs1) + parseInt(that.sectBk1) + parseInt(that.sectEd1);
            var avgSaleSum = parseInt(that.sectSr2) + parseInt(that.sectDg2) + parseInt(that.sectCo2) + parseInt(that.sectKy2) ;
            var avgMngtSum = parseInt(that.sectAs2) + parseInt(that.sectBk2) + parseInt(that.sectEd2);

            var total = saleSum + mngtSum;
            var avgTotal = avgSaleSum + avgMngtSum;

            that.mySale = Math.round(saleSum/total*100); // 나의 판매
            that.myMngt = Math.round(mngtSum/total*100); // 나의 관리

            that.avgSale = Math.round(avgSaleSum/avgTotal*100); // 평균 나의 판매
            that.avgMngt = Math.round(avgMngtSum/avgTotal*100); // 평균 나의 관리

            if (saleSum == 0) {
                that.mySale = 0;
            } // 나의 판매
            if (mngtSum == 0) {
                that.myMngt = 0;
            } // 나의 판매
            if (avgSaleSum == 0) {
                that.avgSale = 0;
            } // 나의 판매
            if (avgMngtSum == 0) {
                that.avgMngt = 0;
            } // 나의 판매                        
                
            }
        })
        .catch(function(error) {
            alert(error.rtMsg);
        });
  },
  methods: {

    heightChk: function(sect) {
        var barSize = sect * 5  ; 
        if(barSize > 100) {
            barSize = 100;
        }
        return barSize;
    }, 
    widthChk: function(sect) {
        var barSize = sect * 5  ; 
        if(barSize > 100) {
            barSize = 100;
        }
        return barSize;
    },  
    cusTab: function(name) {
        this.activeTab = name;
        if(this.activeTab == 'ave') this.view = false;
        else this.view = true;        
    },
  }
};
</script>
